import { SET, RESET_STATE } from "@/stores/CommumActionTypes";
import { SET_COMPANY_EMAILS } from "../actions/Companies";

const actions = {
	[SET]: ({ commit }, company) =>
	{
		commit(SET, company);
	},
	[RESET_STATE]: ({ commit }) =>
	{
		commit(RESET_STATE);
	},
	[SET_COMPANY_EMAILS]: ({ commit }, emails) =>
	{
		commit(SET_COMPANY_EMAILS, emails);
	}
};

export default { actions };
